import {
    getDataWithParams,
    getAllData
} from '@/store/api/method'
const initialState = () => ({
    items: [],
    detail: [],
    msg: 'Jaringan Bermasalah',
    status: 0,
    request: {semester: null},
    khs: []
})
const state = initialState
 
const getters = {
    getItems: state => (type) => state.items[type] || [],
    getDetail: state => (npm) => state.detail[npm] || {},
    getRequest: state => state.request,
    getMsg: state => state.msg,
    getStatus: state => state.status,
    getKHS: state => state.khs
}

const actions = {
    async fetchData({
        commit, state
    }, {url, request = null, type}) {
        try {
            if(request != null){
                state.request = request
            }
            var response = await getDataWithParams(url,request);
            commit('SET_DATA',{response: response.data, type: type});
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    async getKHSData({
        commit
    }, semester_id) {
        try {
            var response = await getDataWithParams('my-krs',{semester: semester_id});
            commit('SET_KHS',response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    async getDetailData({
        commit
    }, {url, npm}) {
        try {
            var response = await getAllData(url);
            commit('SET_DETAIL',{response: response.data, npm: npm});
        } catch (_) {
            commit('SET_FAILED')
        }
    },
}

const mutations = {
    SET_FAILED(state) {
        state.msg = 'Jaringan Bermasalah'
        state.status = 0
    },
    SET_DATA(state, {response, type}) {
        state.msg = response.msg
        state.status = response.status
        state.items[type] = response.data
    },
    SET_KHS(state, response) {
        state.msg = response.msg
        state.status = response.status
        state.khs = response.data
    },
    SET_DETAIL(state, {response, npm}) {
        state.msg = response.msg
        state.status = response.status
        state.detail[npm] = response.data
    },
    SET_RESPONSE(state, response) {
        state.msg = response.msg
        state.status = response.status
    },
    resetState (state) {
        const initial = initialState()
        Object.keys(initial).forEach(key => { state[key] = initial[key] })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}